module.exports = __webpack_public_path__ + "img/8.47792c03.jpg";